import React from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'

import CloseIcon from 'assets/icons/close-icon'
import ErrorIcon from 'assets/icons/warning-icon'
import WarningIcon from 'assets/icons/warning_icon'
import InfoIcon from 'assets/icons/information-icon'

const CloseButton = styled.div`
  margin-right: 16px;
`
const StyledInfoIcon = styled.div`
  padding-left: 12px;
`
const StyledText = styled.div`
  margin-left: 20px;
  color: #202020;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
`

const toastCloseButton = ({ closeToast }) => {
  return (
    <CloseButton onClick={closeToast}>
      <CloseIcon />
    </CloseButton>
  )
}

const toastIcons = (state) => {
  return <StyledInfoIcon>{state === 'error' ? <ErrorIcon /> : state === 'warning' ? <WarningIcon /> : <InfoIcon />}</StyledInfoIcon>
}

export const showErrorToast = (notificationText, showBorder) => {
  return toast(<StyledText>{notificationText}</StyledText>, {
    icon: toastIcons('error'),
    className: `${showBorder ? 'Toastify__toast--error--with-border' : 'Toastify__toast--error--without-border'}`,
    closeButton: toastCloseButton
  })
}

export const showSuccessToast = (notificationText, showBorder) => {
  return toast(<StyledText>{notificationText}</StyledText>, {
    icon: toastIcons('success'),
    className: `${showBorder ? 'Toastify__toast--success--with-border' : 'Toastify__toast--success--without-border'}`,
    closeButton: toastCloseButton
  })
}

export const showWarningToast = (notificationText, showBorder) => {
  return toast(<StyledText>{notificationText}</StyledText>, {
    icon: toastIcons('warning'),
    className: `${showBorder ? 'Toastify__toast--warning--with-border' : 'Toastify__toast--warning--without-border' }`,
    closeButton: toastCloseButton
  })
}

